/**
 * Builds the stable react-hook-form key for a checklist item.
 *
 * The form stores `Checklist_Items` as an object keyed by this value (not as an
 * array) so each item's decision/comment stays anchored to the item itself,
 * regardless of the visible order. The `item_` / `temp_` prefix also forces RHF
 * to treat the key as an object property rather than a numeric array index.
 *
 * This MUST stay identical everywhere a form key is derived (reset, render and
 * submit), otherwise keys won't line up and data can leak between items.
 */
export const buildChecklistFormKey = (item, idx) =>
  item?.id != null ? `item_${item.id}` : `temp_${idx}_${(item?.text || '').replace(/\W/g, '_').slice(0, 20)}`;

/**
 * Returns true when the loaded checklist definition belongs to the given job
 * opening. Used to avoid resetting/submitting a checklist that still belongs to
 * a previously viewed interview while the current one is still loading.
 */
export const checklistBelongsToJobOpening = (checklistItems, jobOpeningId) =>
  checklistItems?.JobOpeningId != null &&
  jobOpeningId != null &&
  `${checklistItems.JobOpeningId}` === `${jobOpeningId}`;
